import isBlank from "utils/isBlank";

export default function isPresent(value: any): boolean {
  return !isBlank(value);
}
